<style lang="scss" scoped>
input {
	padding: 10px;
	width: 90%;
	border-radius: 5px;
	border: 1px solid darken(#eee, 20);
}
tr {
	td.green {
		color: green;
		font-weight: bold;
	}
	td:first-child {
		padding-left: 40px !important;
	}
	td:last-child {
		padding-right: 40px !important;
	}
}
</style>

<template>
	<tr>
		<td>
			<strong>{{ user.forename }} {{ user.surname }}</strong>
			<br />
			{{ user.email }}
		</td>
		<td>
			Parent: {{ parent.contact_forename }} {{ parent.contact_surname }}
			<br />
			Parental Responsibility: {{ parent.contact_parental_responsibility }}
			<br />
			Priority: {{ parent.contact_priority }}
		</td>
		<td>
			<input type="text" v-model="user.selectedParentRow.contact_email" />
		</td>
		<td>
			<input type="text" v-model="user.selectedParentRow.contact_phone" />
		</td>
		<td style="text-align:center">
			<el-button @click="swap" :disabled="user.Parents.length < 2" plain>Swap</el-button>
		</td>
		<td
			style="text-align:center"
			:class="{ 'green': user.previousComms }"
		>{{ user.previousComms ? "Yes" : "No"}}</td>
		<td style="text-align:right">
			<el-button
				@click="user.selected = !user.selected"
				:type="type"
			>{{ user.selected ? "Selected" : "Excluded" }}</el-button>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		user: Object
	},

	data() {
		return {
			selectedParent: 0
		};
	},

	computed: {
		parent() {
			return this.user.Parents[this.selectedParent];
		},

		type() {
			return this.user.selected ? "success" : "plain";
		}
	},

	methods: {
		swap() {
			if (this.user.Parents[this.selectedParent + 1]) {
				this.selectedParent++;
			} else {
				this.selectedParent = 0;
			}
			this.user.selectedParentRow = this.user.Parents[this.selectedParent];
		}
	}
};
</script>